import { TemplateConfig } from '../types';

export const generalYesNoConfig: TemplateConfig = {
  id: 'general-yes-no',
  name: '非特定模板',
  description: '处理一般性的是否类问题',
  cardCount: 3,
  
  fieldDefaults: {
  },
  
  disabledFields: [], // 该模板不禁用任何字段，用户可以自定义
  
  // 特殊分类标识，用于UI分组
  specialCategory: 'non-specific',
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#52c41a',
    backgroundColor: '#f6ffed',
    icon: '❓'
  },

  spreadLayout: {
    coordinate: 'normalized',
    cardSize: {
      widthRatio: 0.25,
      heightRatio: 0.65875,
      anchor: 'center'
    },
    positions: [
      { x: 0.2, y: 0.5 },
      { x: 0.5, y: 0.5 },
      { x: 0.8, y: 0.5 }
    ]
  }
};
